import ChangeEnum from "../interfaces/frontend/ChangeEnum";
import Icons from "./Icons";

// "Change" and "difference" are considered synonymous.

export interface IInhibitorDiffOption {
    value: ChangeEnum,
    label: string,
    icon: keyof typeof Icons,
    textCls: string,
}

export const InhibitorDiffOptions: IInhibitorDiffOption[] = [
    {
        value: ChangeEnum.DecreaseLarge,
        label: "Large decrease",
        icon: "decreaseLarge",
        textCls: 'll-decrease',
    },
    {
        value: ChangeEnum.DecreaseModerate,
        label: "Moderate decrease",
        icon: "decreaseModerate",
        textCls: 'll-decrease',
    },
    {
        value: ChangeEnum.NoChange,
        label: "No change",
        icon: "noChange",
        textCls: 'll-no-change',
    },
    {
        value: ChangeEnum.IncreaseModerate,
        label: "Moderate increase",
        icon: "increaseModerate",
        textCls: 'll-increase',
    },
    {
        value: ChangeEnum.IncreaseLarge,
        label: "Large increase",
        icon: "increaseLarge",
        textCls: 'll-increase',
    },
]


export const InhibitorDiffOptionsIndex: {[key: string]: IInhibitorDiffOption} = Object.fromEntries(
    InhibitorDiffOptions.map(o => [ChangeEnum[o.value], o])
)
